export const PRODUCT_TYPES = {
  STUDY_NOW_PAY_LATER: 'SNP',
  PAYMENT_ASSIST: 'PAS',
  ALL_PRODUCTS: 'ALL'
};

export const FEE_PAID_BY_LABELS: Record<string, string> = {
  EP: 'EP',
  STUDENT: 'Student'
};

export const MILLISECOND = 1; // Used for readability purposes
export const SECOND = MILLISECOND * 1000;
export const MINUTE = SECOND * 60;
export const HOUR = MINUTE * 60;
